import React from 'react';
import { inject, observer } from "mobx-react";
import { MessageBox } from 'react-chat-elements';

import './InsuranceFieldMessage.css';

import leonardoStore from '../../../../stores/leonardoStore'

const OwnerForm = observer(() => {
  const owner = leonardoStore.leonardoInsurance.owner;

  const handleChange = (e) => {
    const { name, value } = e.target;
    owner[name] = value;
  };

  return (
    <form>
      {Object.keys(owner).map((key) => (
        <div key={key}>
          <label>{key}</label>
          <input
            name={key}
            value={owner[key] || ""}
            onChange={handleChange}
          />
        </div>
      ))}
    </form>
  );
});

const InsuranceFieldMessage = observer((date, dateString) => {

    return (
      <MessageBox
          className="insurance-field-message"
          text={<OwnerForm />}
          position="left"
          date={date}
          dateString={dateString}
          notch={true}
      />
    );
});

export default InsuranceFieldMessage;